module.exports = __webpack_public_path__ + "img/water-meter-hot-md.ed4bc27d.svg";